import { ApplicationWithDetails } from '../../../types';
import { BrandPanelDetails } from './BrandPanelDetails/BrandPanelDetails';
import { BrandPanelInstructions } from './BrandPanelInstructions/BrandPanelInstructions';

export const BrandPanel: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EBF22`,
	name: `Цифровая панель брендов`,
	description: `Диджитал панель с выручкой брендов\xa0сети.`,
	descriptionLong: `Пока вы моргнули, мы уже приняли 5 заказов!\n\nОткрытость – ключевая ценность нашей компании. Мы открыто показываем выручки всей сети Dodo Brands, количество точек каждого бренда, количество стран и другие метрики. На интерактивной карте непрерывно мерцают огонёчки — это новые заказы в городах по всему миру в реальном времени. Как говорил классик, бесконечно можно смотреть на 3 вещи: как горит огонь, как течёт вода и как клиенты Dodo делают новые заказы по всему миру.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/digitalbp/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/digitalbp/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/digitalbp/slider1`,
		`https://cdn.dodostatic.net/static/marketplace/digitalbp/slider2`,
		`https://cdn.dodostatic.net/static/marketplace/digitalbp/slider3`,
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: ``,
	supportUrl: `https://realtime.dodobrands.io/?source=marketplace`,
	redirectUrl: `https://realtime.dodobrands.io/?source=marketplace`,
	contactEmail: `support@dodopizza.com`,
	supportEmail: ``,
	categories: [`Офис`],
	countries: [`Все`],
	languages: [`English`],
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	price: `Бесплатно`,
	type: `ТВ-Борд`,
	version: `1.0`,
	developer: `Dodo Brands`,
	plans: null,
	instructions: BrandPanelInstructions,
	details: BrandPanelDetails,
	knowledgeBase: null,
	isExternal: false,
	showInstruction: false,
	versionHistory: null,
	goToApp: true,
	isFreeForAllRoles: true,
	isOpenForUnauthorized: true,
};
